import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
// {
//   SAI: window.settings.language === 'zh_CN' ? [0.11, 0.13] : [0.2, 0.4],
//     SRI: window.settings.language === 'zh_CN' ? [0.02, 0.08] : [0, 0.4],
//       IS: 1.4
// }
const DEFAULTSET = {
  SAI: [0.4, 1],
  SRI: [1.55, 1.97],
  SDP: [0.37, 1.33],
  DSI: [1.73, 3.26],
  OSI: [1.85, 2.04],
  CSI: [0.7, 0.9],
  IAI: [0.19, 0.49],
  KPI: [0.23, 0.3],
  IS: [1.4, 1.8],
  KISA: [0.6, 1]
  // en_US: {
  //   SAI: [0.4, 1],
  //   SRI: [1.55, 1.97],
  //   SDP: [0.37, 1.33],
  //   DSI: [1.73, 3.26],
  //   OSI: [1.85, 2.04],
  //   CSI: [0.7, 0.9],
  //   IAI: [0.19, 0.49],
  //   KPI: [0.23, 0.3],
  //   IS: [1.4, 1.8]
  // },
  // zh_CN: {
  //   SAI: [0.11, 0.13],
  //   SRI: [0.02, 0.08],
  //   SDP: [0.37, 1.33],
  //   DSI: [1.73, 3.26],
  //   OSI: [1.85, 2.04],
  //   CSI: [0.7, 0.9],
  //   IAI: [0.19, 0.49],
  //   KPI: [0.23, 0.3],
  //   IS: [1.4, 1.8]
  // }
};
class KeratoconusStd extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("keratoconusStd.json"), DEFAULTSET);
  }
  getKeratoconusStd() {
    return this.getSettings();
  }
  saveKeratoconusStd(settings) {
    this.saveSettings(settings);
  }
}
export default KeratoconusStd;



// WEBPACK FOOTER //
// ./src/settings/keratoconusStd.js